import { Link } from 'react-router-dom';
import { Globe, Link as LinkIcon } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const mobileItemCls = (active) => (
  `flex items-center gap-3 px-4 py-3 rounded-sm transition-colors duration-200 ${
    active ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
  }`
);

export const MobileNav = ({ user, navLinks, adminLinks, isActive, onClose }) => {
  const { t, language, toggleLanguage } = useLanguage();

  return (
    <div className="md:hidden border-t border-white/10 bg-card">
      <nav className="px-6 py-4 space-y-1">
        {navLinks.map(({ path, label, icon: Icon }) => (
          <Link
            key={path}
            to={path}
            onClick={onClose}
            className={mobileItemCls(isActive(path))}
          >
            <Icon className="w-5 h-5" />
            {label}
          </Link>
        ))}

        {user?.role === 'parent' && (
          <Link
            to="/link-student"
            onClick={onClose}
            className={mobileItemCls(isActive('/link-student'))}
          >
            <LinkIcon className="w-5 h-5" />
            {t('nav.linkChild')}
          </Link>
        )}

        {user?.role === 'admin' && (
          <>
            <div className="pt-4 pb-2 px-4 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              {t('nav.admin')}
            </div>
            {adminLinks.map(({ path, label, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                onClick={onClose}
                className={mobileItemCls(isActive(path))}
              >
                <Icon className="w-5 h-5" />
                {label}
              </Link>
            ))}
          </>
        )}

        <button
          onClick={toggleLanguage}
          className="flex items-center gap-3 px-4 py-3 rounded-sm w-full text-left text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors duration-200"
        >
          <Globe className="w-5 h-5" />
          {language === 'de' ? 'Switch to English' : 'Zu Deutsch wechseln'}
        </button>
      </nav>
    </div>
  );
};
